// extracted by mini-css-extract-plugin
module.exports = {"notFound":"NotFound_notFound__3CEjn","heading":"NotFound_heading__2lNQV","description":"NotFound_description__1uh8N"};